import { Settings } from '@/screens/settings';

export default function SettingsScreen() {
  return <Settings />;
}
